export enum DocumentBuyerVisibilityConditions {
    FileApprovedBySeller = 0,
    DfmFeePaid = 1,
    IdNdaSigned = 2,
    DataNdaSignedAny = 3,
    DataNdaSignedFullyBlinded = 4,
    DataNdaSignedDvmsBlinded = 5,
    DataNdaSignedStaffBlinded = 6,
    DataNdaSignedFullyVisible = 7,
}

export const DataNdaSignedConditionsOptions = {
    [DocumentBuyerVisibilityConditions.DataNdaSignedAny]: 'Any',
    [DocumentBuyerVisibilityConditions.DataNdaSignedFullyBlinded]:
        'Fully blinded',
    [DocumentBuyerVisibilityConditions.DataNdaSignedDvmsBlinded]:
        'DVMs / Management blinded',
    [DocumentBuyerVisibilityConditions.DataNdaSignedStaffBlinded]:
        'Staff blinded',
    [DocumentBuyerVisibilityConditions.DataNdaSignedFullyVisible]:
        'Fully visible',
};

export const DataNdaSignedConditionsOptionsMapping = [
    {
        value: DocumentBuyerVisibilityConditions.DataNdaSignedAny,
        label: DataNdaSignedConditionsOptions[
            DocumentBuyerVisibilityConditions.DataNdaSignedAny
        ],
    },
    {
        value: DocumentBuyerVisibilityConditions.DataNdaSignedFullyBlinded,
        label: DataNdaSignedConditionsOptions[
            DocumentBuyerVisibilityConditions.DataNdaSignedFullyBlinded
        ],
    },
    {
        value: DocumentBuyerVisibilityConditions.DataNdaSignedDvmsBlinded,
        label: DataNdaSignedConditionsOptions[
            DocumentBuyerVisibilityConditions.DataNdaSignedDvmsBlinded
        ],
    },
    {
        value: DocumentBuyerVisibilityConditions.DataNdaSignedStaffBlinded,
        label: DataNdaSignedConditionsOptions[
            DocumentBuyerVisibilityConditions.DataNdaSignedStaffBlinded
        ],
    },
    {
        value: DocumentBuyerVisibilityConditions.DataNdaSignedFullyVisible,
        label: DataNdaSignedConditionsOptions[
            DocumentBuyerVisibilityConditions.DataNdaSignedFullyVisible
        ],
    },
];
